export default function EditWebsiteTools() {
  return <div>Theme Tools Page</div>;
}
